<div class="relative grid bg-gray-100 dark:bg-black/20 rounded-2xl p-1.5"
    [style.grid-template-columns]="'repeat(' + options.length + ', 1fr)'">
    <div class="absolute top-1.5 bottom-1.5 bg-white dark:bg-gray-700 rounded-[32px] shadow-sm transition-all duration-300 ease-out z-0"
        [style.left]="'6px'"
        [style.width]="'calc((100% - 12px) / ' + options.length + ')'"
        [style.transform]="'translateX(' + getSelectedIndex() * 100 + '%)'">
    </div>
    <button *ngFor="let option of options; let i = index" type="button"
        [class.text-gray-900]="isSelected(option.value)"
        [class.dark:text-white]="isSelected(option.value)"
        [class.font-semibold]="isSelected(option.value)"
        [class.text-gray-500]="!isSelected(option.value)"
        [class.dark:text-gray-400]="!isSelected(option.value)"
        (click)="selectOption(option.value)"
        class="relative z-10 px-3 py-2 border-none bg-transparent rounded-[32px] text-sm font-medium cursor-pointer transition-colors duration-200 whitespace-nowrap text-center hover:text-gray-700 dark:hover:text-gray-200 inline-flex items-center justify-center gap-1.5">
        <span *ngIf="option.icon" class="material-symbols-rounded text-[16px]">{{ option.icon }}</span>
        {{ option.label }}
    </button>
</div>